import React from 'react';
import WeatherIcons from 'react-weathericons';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@ro-styles/libs/weathericons/weather-icons.min.scss';
import '@ro-styles/libs/weathericons/weather-icons-wind.min.scss';
import './icon.scss';
import { Props } from './Icon.types';

const Icon = (props: Props) => {
  const { weather, style, ...others } = props;
  return (
    <span style={style}>
      {props.weather ? <WeatherIcons {...others} /> : <i className={`fa-${others.name}`} {...others} />}
    </span>
  );
};

export default Icon;
